import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PeopleMergeRecords from './PeopleMergeRecords'
import PeopleMergeForm from './PeopleMergeForm'

const MergeProfilesRouter = ({ mergeType = 'people' }) => {
  if (mergeType === 'organizations') {
    // TODO: Organization merge routes
    return null
  }

  return (
    <Switch>
      <Route exact path="/merge-profiles/people/new" component={PeopleMergeForm} />
      <Route exact path="/merge-profiles/people" component={PeopleMergeRecords} />
    </Switch>
  )
}

export default MergeProfilesRouter
